/* Interactions d'interface. Sans librairie. Tout est facultatif :
   si le script ne tourne pas, les liens et les formulaires restent utilisables. */
(function () {

  /* ---------- navigation mobile ---------------------------------------- */
  function menuMobile() {
    var entete = document.querySelector('.section-entete');
    var ouvreur = document.querySelector('[data-ouvre-menu]');
    var tiroir = document.querySelector('[data-menu-mobile]');
    if (!entete || !ouvreur || !tiroir) return;
    var fonds = [], debordement = '';
    // Largeur à partir de laquelle le burger laisse place à la navigation : 990 px, 1140 px sur
    // l'accueil (en-tête Prop 2). En dessous, le focus revient au burger et le tiroir reste ouvert.
    var bureau = '(min-width: ' + (parseInt(ouvreur.getAttribute('data-seuil-bureau'), 10) || 990) + 'px)';
    function bascule(v) {
      if (v === !tiroir.hidden) return;
      tiroir.hidden = !v;
      ouvreur.setAttribute('aria-expanded', String(v));
      if (v) debordement = document.documentElement.style.overflow;
      document.documentElement.style.overflow = v ? 'hidden' : debordement;
      if (v) { var p = tiroir.querySelector('button[data-ferme-menu]') || tiroir.querySelector('a, button'); if (p) p.focus(); }
      if (v) {
        entete.dispatchEvent(new CustomEvent('chanoyu:menu-mobile-ouvert'));
        var branche = tiroir;
        while (branche.parentElement) {
          Array.from(branche.parentElement.children).forEach(function (el) {
            if (el !== branche && !el.inert && !/^(SCRIPT|STYLE|LINK)$/.test(el.tagName)) { el.inert = true; fonds.push(el); }
          });
          branche = branche.parentElement;
          if (branche === document.body) break;
        }
      } else {
        fonds.forEach(function (el) { el.inert = false; }); fonds = [];
        var retour = window.matchMedia(bureau).matches ? entete.querySelector('.section-entete__declencheur, .section-entete__marque') : ouvreur;
        if (retour) retour.focus();
      }
    }
    ouvreur.addEventListener('click', function () { bascule(tiroir.hidden); });
    entete.addEventListener('chanoyu:menu-fermer', function () { bascule(false); });
    tiroir.addEventListener('click', function (e) {
      if (e.target.closest('[data-ferme-menu]')) bascule(false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !tiroir.hidden) { bascule(false); ouvreur.focus(); }
      if (e.key === 'Tab' && !tiroir.hidden) {
        var elements = Array.from(tiroir.querySelectorAll('a[href], button:not(:disabled)')).filter(function (el) { return el.getClientRects().length; });
        var premier = elements[0], dernier = elements[elements.length - 1];
        if (premier && e.shiftKey && document.activeElement === premier) { e.preventDefault(); dernier.focus(); }
        else if (dernier && !e.shiftKey && document.activeElement === dernier) { e.preventDefault(); premier.focus(); }
      }
    });
    window.addEventListener('resize', function () { if (window.matchMedia(bureau).matches && !tiroir.hidden) bascule(false); });
  }

  /* ---------- filtres et tri de collection ------------------------------ */
  function filtres() {
    var zone = document.querySelector('[data-filtres]');
    var grille = document.querySelector('[data-grille]');
    if (!zone || !grille) return;
    var cartes = Array.prototype.slice.call(grille.querySelectorAll('[data-type]'));
    var compte = document.querySelector('[data-compte-resultats]');
    var gabarit = compte ? compte.getAttribute('data-gabarit') : '{n} résultats';

    zone.addEventListener('click', function (e) {
      var b = e.target.closest('[data-filtre]');
      if (!b) return;
      var cle = b.getAttribute('data-filtre');
      zone.querySelectorAll('[data-filtre]').forEach(function (x) { x.classList.remove('est-actif'); });
      b.classList.add('est-actif');
      var visibles = 0;
      cartes.forEach(function (c) {
        var ok = cle === '*' || c.getAttribute('data-type') === cle;
        c.hidden = !ok;
        if (ok) visibles++;
      });
      if (compte) compte.textContent = gabarit.replace('{n}', visibles);
    });

    var tri = document.querySelector('[data-tri]');
    if (tri) tri.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.delete('page');
      if (tri.value) url.searchParams.set('sort_by', tri.value);
      else url.searchParams.delete('sort_by');
      window.location.href = url.toString();
    });
  }

  /* ---------- ajout rapide depuis une carte ----------------------------- */
  function ajoutRapide() {
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-ajout-rapide]');
      if (!b) return;
      e.preventDefault();
      var id = b.getAttribute('data-variante');
      if (!id) return;
      var libelle = b.textContent;
      b.textContent = 'Ajout…';
      b.disabled = true;
      var zoneErreur = b.closest('.carte-the') || b.parentElement;
      var ancienneErreur = zoneErreur.querySelector('[data-erreur-ajout]');
      if (ancienneErreur) ancienneErreur.remove();
      fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (data) { throw new Error(data.description || 'Ajout impossible. Réessayez.'); });
        document.dispatchEvent(new CustomEvent('chanoyu:panier-modifie'));
      }).catch(function (erreur) {
        var statut = zoneErreur.querySelector('[data-erreur-ajout]');
        if (!statut) {
          statut = document.createElement('p');
          statut.setAttribute('data-erreur-ajout', '');
          statut.setAttribute('role', 'alert');
          zoneErreur.appendChild(statut);
        }
        statut.textContent = erreur.message;
      }).then(function () {
        b.textContent = libelle; b.disabled = false;
      });
    });
  }

  /* ---------- pas de quantité sur la fiche produit ---------------------- */
  function quantite() {
    document.addEventListener('click', function (e) {
      var b = e.target.closest('.section-fiche__quantite button');
      if (!b || b.closest('[data-pdp]')) return;
      e.preventDefault();
      var champ = b.parentElement.querySelector('input');
      if (!champ) return;
      var v = parseInt(champ.value, 10) || 1;
      var plus = b.getAttribute('aria-label') && b.getAttribute('aria-label').indexOf('Ajouter') === 0;
      champ.value = Math.max(1, plus ? v + 1 : v - 1);
      champ.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* ---------- galerie produit ------------------------------------------- */
  function galerie() {
    var galerie = document.querySelector('.section-fiche__galerie');
    if (!galerie || galerie.closest('[data-pdp]')) return;
    var principale = galerie.querySelector('.section-fiche__img');
    if (!principale) return;
    galerie.addEventListener('click', function (e) {
      var v = e.target.closest('.section-fiche__vignette');
      if (!v) return;
      var img = v.querySelector('img');
      if (!img) return;
      galerie.querySelectorAll('.section-fiche__vignette').forEach(function (x) { x.classList.remove('est-actif'); });
      v.classList.add('est-actif');
      principale.src = v.getAttribute('data-image') || img.currentSrc || img.src;
      principale.alt = v.getAttribute('data-alt') || img.alt;
      principale.removeAttribute('srcset');
    });
  }

  function variantes() {
    document.addEventListener('change', function (e) {
      var choix = e.target;
      if (!choix.matches('.section-fiche__formats input[name="id"]') || choix.closest('[data-pdp]')) return;
      var fiche = choix.closest('.section-fiche');
      var disponible = choix.dataset.disponible === 'true';
      fiche.querySelectorAll('.section-fiche__format').forEach(function (el) {
        el.classList.toggle('est-actif', el.contains(choix));
      });
      fiche.querySelector('.section-fiche__prix').textContent = choix.dataset.prix;
      var bouton = fiche.querySelector('.section-fiche__ajouter');
      bouton.disabled = !disponible;
      bouton.textContent = disponible ? 'Ajouter au panier · ' + choix.dataset.prix : 'Épuisé';
      var stock = fiche.querySelector('.section-fiche__stock');
      stock.textContent = disponible ? stock.dataset.stockDisponible : 'Ce format est épuisé.';
      var infos = fiche.querySelector('[data-infos-format]');
      var modele = fiche.querySelector('[data-infos-variante="' + choix.value + '"]');
      if (infos && modele) infos.replaceChildren(modele.content.cloneNode(true));
      var barre = document.querySelector('[data-barre]');
      if (barre) {
        barre.querySelector('[data-barre-prix]').textContent = choix.dataset.prix;
        barre.querySelector('.section-barre__format').textContent = choix.dataset.format;
      }
      var image = fiche.querySelector('.section-fiche__img');
      if (image && choix.dataset.image) {
        image.src = choix.dataset.image;
        image.removeAttribute('srcset');
        fiche.querySelectorAll('.section-fiche__vignette').forEach(function (el) {
          el.classList.toggle('est-actif', el.dataset.image === choix.dataset.image);
        });
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', choix.value);
      window.history.replaceState({}, '', url);
    });
  }

  function demarrer() { menuMobile(); filtres(); ajoutRapide(); quantite(); galerie(); variantes(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer);
  else demarrer();
})();
